import React from "react";
import "./App.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import FormacionSection from "./components/FormacionSection";
import ServicesSection from "./components/ServicesSection";
import BlogSection from "./components/BlogSection";
import TesoroSection from "./components/TesoroSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App bg-black text-white overflow-x-hidden">
      <Header />
      <HeroSection />
      <AboutSection />
      <FormacionSection />
      <ServicesSection />
      <BlogSection />
      <TesoroSection />
      <ContactSection />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
